import { Title, Flex, Center } from "@mantine/core";

const Header = () => {
  return (
    <Center>
      <Flex
        component="nav"
        align="center"
        justify="space-between"
        wrap="wrap"
        p="0.5rem"
        mt={10}
        mb={10}
      >
        <Flex align="center" mr={20}>
          <Title order={1}>
            Delectatech Stages
          </Title>
        </Flex>
      </Flex>
    </Center>
  );
};

export default Header;